/* Hook encargado de modificar el Mensaje

Autor: Myrta Ravanal
Fecha: 2025-01-08
*/
import { useState } from 'react'

import { customPost } from '../utils/customFetch.ts'
import Message from '../interfaces/Message.ts'

import {
  makeUrlMessageAssign,
  makeUrlMessageEdit,
  makeUrlMessageProcess,
  makeUrlMessageDiscard,
} from './connectionData.tsx'

const useMessagePoster = () => {
  const [errorPostMessage, setErrorPostMessage] = useState<Error | null>(null)
  const [loadingPost, setLoadingPost] = useState<boolean>(false)
  const [errorPostMessageAssign, setErrorPostMessageAssign] = useState<Error | null>(null)
  const [errorPostMessageDiscard, setErrorPostMessageDiscard] = useState<Error | null>(null)
  const [errorPostMessageProcess, setErrorPostMessageProcess] = useState<Error | null>(null)

  const postMessageEdit = async (message: Message) => {
    setLoadingPost(true)
    const apiParams = { message: message }

    try {
      const apiUrl = makeUrlMessageEdit()
      await customPost(apiUrl, apiParams)

      setErrorPostMessage(null)

      return 'OK'
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorPostMessage(err)
      } else {
        setErrorPostMessage(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoadingPost(false)
    }
  }

  const postMessageAssign = async (messageId: string, profileId: string) => {
    setLoadingPost(true)
    const apiParams = { messageId, profileId }

    try {
      const apiUrl = makeUrlMessageAssign()
      await customPost(apiUrl, apiParams)

      setErrorPostMessageAssign(null)

      return 'OK'
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorPostMessageAssign(err)
      } else {
        setErrorPostMessageAssign(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoadingPost(false)
    }
  }

  const postMessageDiscard = async (messageId: string) => {
    setLoadingPost(true)
    const apiParams = { messageId }

    try {
      const apiUrl = makeUrlMessageDiscard()
      await customPost(apiUrl, apiParams)

      setErrorPostMessageDiscard(null)

      return 'OK'
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorPostMessageDiscard(err)
      } else {
        setErrorPostMessageDiscard(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoadingPost(false)
    }
  }
  const postMessageProcess = async (messageId: string, dealId: string) => {
    setLoadingPost(true)
    const apiParams = { messageId, dealId }

    try {
      const apiUrl = makeUrlMessageProcess()
      await customPost(apiUrl, apiParams)

      setErrorPostMessageProcess(null)

      return 'OK'
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorPostMessageProcess(err)
      } else {
        setErrorPostMessageProcess(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoadingPost(false)
    }
  }

  // Exponemos estas variables al exterior
  return {
    loadingPost,
    postMessageAssign,
    errorPostMessageAssign,
    postMessageDiscard,
    errorPostMessageDiscard,
    postMessageEdit,
    errorPostMessage,
    postMessageProcess,
    errorPostMessageProcess,
  }
}

export default useMessagePoster
